import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import React from 'react';

const liStyle = { marginBottom: 10 };

const legacyCompaniesCardContent: JSX.Element = (
  <Stack>
    <ul>
      <li style={liStyle}>Company &#38; service contacts information</li>
      <li style={liStyle}>Filing requirements, filing status &#38; dividend information</li>
      <li style={liStyle}>Document archive</li>
      <li style={liStyle}>Process &#38; milestone management</li>
    </ul>
  </Stack>
);

export default legacyCompaniesCardContent;
